/*eslint-disable */

import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'upgrade-now-payment-checkout',
  components: {
  },
  props: [],
  data () {
    return {
      selfUserId:'',
      auto_renew:true,
      start_payment :'',
      isSubmitted:false,
      selfUserInfo:null,
      domainLocationOrigin:''
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters'
    ]),
    getUserDetailsAgainFun(){
      this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data
      return;
    },
  },
  mounted () {
    this.domainLocationOrigin = window.location.origin
    this.getUserDetailsAgainFun
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
  },
  methods: {
    createSubscriptionMethod() {
      this.isSubmitted = true
      let formData = {
        plan_id : this.$route.query.plan_id,
        id:this.selfUserId,
        application_context:{
          return_url: this.domainLocationOrigin + '/payment/success/',
          cancel_url:this.domainLocationOrigin + '/payment/failed/',
        }
      };
      this.$store.dispatch('postPlanSubscribeFunc', formData).then((res) => {
        let linkOfPayPal =  res.data.links[0].href
        let subscData = new FormData();
        var details = JSON.stringify({subscription_id :res.data.id});
        subscData.append('user', details);
        this.$store.dispatch('updateProfileFun', subscData).then((response) => {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = linkOfPayPal;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          this.isSubmitted = false
        }, 100);
        })
      }).catch((err) => {
        this.isSubmitted = false
      })
    },
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.selfUserInfoGetters;
    },
  },
  beforeRouteLeave: function(to, from, next) {
    next()
  }
}